import { useInView } from "framer-motion";
import { useEffect, useRef } from "react";
import { PRIMARY_COLOR } from "../../utils/constants";
import { LoadingOval } from "../loaders/loaders";

export const SentinelDiv = ({
  onVisible,
  loading,
  className,
}: {
  onVisible: () => void;
  loading: boolean;
  className?: string;
}) => {
  const loader = useRef<HTMLDivElement | null>(null);

  const isInvView = useInView(loader);

  useEffect(() => {
    if (isInvView) {
      onVisible();
    }
    // eslint-disable-next-line
  }, [isInvView]);

  return (
    <>
      {true ? (
        <div ref={loader} style={{ height: "20px" }} className={className} />
      ) : undefined}
      {loading ? (
        <div className="flex w-full justify-center">
          <LoadingOval
            color={PRIMARY_COLOR}
            loaderWidth="20"
            loaderHeight="20"
          />
        </div>
      ) : undefined}
    </>
  );
};
